import AuthService from './authService'
import axios from 'axios'

function useAuth (overrideConfig) {
    const axiosIns = axios.create({
        baseURL: overrideConfig.baseURL
    })
    const auth = new AuthService(axiosIns, overrideConfig)
    return {
        auth
    }
}

const { auth } = useAuth(axios, {})

export {
    useAuth,
    auth
}
